import enquire from 'enquire-js';
import { tns } from 'tiny-slider/src/tiny-slider.module';

/**
 * Initialize slider on mobile, destroy it when we go
 * back to desktop width
 */

const columnSlider = document.querySelectorAll('.wp-block-csccanada-columns');

let tnsSlider = [];

export default enquire.register('screen and ( max-width: 767px )', {
	match: () => {
		columnSlider.forEach(slider => {
			tnsSlider.push(
				tns({
					container: slider,
					slideBy: 'page',
					nav: true,
					controlsText: ['Previous slide', 'Next Slide']
				})
			);
		});
	},
	unmatch: () => {
		tnsSlider.forEach(slider => {
			slider.destroy();
			tnsSlider.pop();
		});
	}
});
